var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.submit}},[_vm._v("次へ")])}
var staticRenderFns = []

export { render, staticRenderFns }